function openDropDownHeaderMenu() {
  const dropDownItem = document.querySelector('.js-drop-down-selector')
  const dropDownList = document.querySelector('.js-drop-down-link')
  const dropDownIcon = document.querySelector('.js-drop-down-icon')

  if (dropDownItem) {
    dropDownItem.addEventListener('click', function () {
      dropDownList.classList.toggle('active')
    })
  } else {
    if (dropDownIcon) {
      dropDownIcon.style.display = 'none'
    }
  }
}
openDropDownHeaderMenu()
